import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
  NoPrint,
  PrintOnly,
  PrintElement,
} from '../../../../components/PrintElement';

import s from './styles.less';

const propTypes = {
  name: PropTypes.string.isRequired,
  services: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      isService: PropTypes.bool,
      expectedDate: PropTypes.string,
      expectedMileage: PropTypes.string,
    }),
  ),
};
const defaultProps = {
  services: [],
};

const ServicesGroup = ({ name, services }) => (
  <PrintElement avoidPageBreak className={s.services_item} key={name}>
    <b>{name}</b>
    {services.map(service => {
      const fullDate = moment(service.expectedDate).format('Do MMMM YYYY');
      const shortDate = moment(service.expectedDate).format('Do MMM YYYY');
      const date = (
        <span>
          <NoPrint>{fullDate}</NoPrint>
          <PrintOnly>{shortDate}</PrintOnly>
        </span>
      );
      return (
        <div key={service.id}>
          {service.isService ? (
            <div>
              <span>
                <NoPrint>Expected Date and mileage based on usage:</NoPrint>
                <PrintOnly>Date / mileage:</PrintOnly> {date} /{' '}
                {service.expectedMileage} miles
              </span>
            </div>
          ) : (
            <div>
              <span>Expected Date: </span>
              {date}
            </div>
          )}
        </div>
      );
    })}
  </PrintElement>
);

ServicesGroup.propTypes = propTypes;
ServicesGroup.defaultProps = defaultProps;

export default ServicesGroup;
